export default "__VITE_ASSET__CxUyZ8KY__"